import { render, staticRenderFns } from "./AffiliateTokenTable.vue?vue&type=template&id=5042e633&scoped=true&"
import script from "./AffiliateTokenTable.vue?vue&type=script&lang=js&"
export * from "./AffiliateTokenTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5042e633",
  null
  
)

export default component.exports